import { getOrCreateContentfulClient } from '@graphql/client'
import { firstFromCollection } from '@graphql/collection'
import type { WebsiteLayoutFragment } from '@graphql/fragments/WebsiteLayoutFragment.graphql'
import { requestQuery } from '@graphql/functions'
import { GetWebsiteLayoutDocument } from '@graphql/queries/GetWebsiteLayout.graphql'

export const fetchWebsiteLayout = async (): Promise<
    WebsiteLayoutFragment | undefined
> => {
    try {
        const client = getOrCreateContentfulClient('/')
        const result = await requestQuery(client, {
            query: GetWebsiteLayoutDocument,
        })
        return firstFromCollection(
            result?.data?.websiteLayoutCollection,
            undefined,
        )
    } catch {
        return undefined
    }
}
